<template>
  

    <div class="mo-mask" v-show="isModalVisible">
        
        <div class="mo-wrapper pos-rel">

            <img class="mo-bg" src="../assets/img/p8.png" />

            <div class="mo-close" @click="this.isModalVisible=false;">X</div>
            <div class="mo-content">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="welc title-p f-green" style="font-size:56px;">Welcome!</div>
                    </div>
                    <div class="col-sm-6">
                        <div class="login">
                            <div class="f-green t-center" style="font-size:28px;">Sign Up</div>
                            <label>Username</label>
                            <input type="email" v-model="LoginForm.username"><br>
                            <label>Password</label>
                            <input type="password" v-model="LoginForm.password"><br>
                            <label>Confirm Password</label>
                            <input type="password" v-model="LoginForm.confirmpassword"><br>
                            <label><input type="checkbox" id="checkbox" v-model="LoginForm.checked" /> &nbsp;I Agree to The&nbsp;</label><a @click="terms" style="text-decoration:underline; cursor:pointer;">Terms of Services</a>
                            <br><br>
                            <div class="t-right"><div class="btn-dark" @click="signUp()">Sign Up</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
    </div>

      
</template>

<script>
    export default {
        name: 'SignUp',
        data() {
            return {
                isModalVisible: false,
                LoginForm: { username: 'admin', password: '', confirmpassword: '', checked:false }
            }
        },
        mounted() {
            this.LoginForm.partyId = this.$route.query.ref;
            this.LoginForm.key = this.$route.query.key;
            this.LoginForm.username = this.$route.query.email;
        },
        methods: {
            show() {
                this.isModalVisible = true;
            },
            signUp() {

                if (!this.LoginForm.checked) {
                    this.$ui.alert(this, "Error", "Please accept the terms of services", "error");
                    
                    return;
                }

                this.$core.SignUp(this.LoginForm).then((data) => {
                    if (data.Message!='') {
                        this.$ui.alert(this, "Error", data.Message, "error");
                    } else {
                        var key = this.$route.query.key;
                        this.$core.data.UserInfo = data.Object;
                        this.$core.data.DisplayPage = 'Info';
                        if (key != null && key != undefined) {
                            this.$core.CheckHasContractToSign(key).then((x) => {
                                //console.log(`After login contract is ${x} for sign`);
                                if (x == true) {
                                    window.open(`/Signature?key=${key}`, '');
                                }
                            });
                        }
                        this.$router.push('/PersonalInfo/0');
                        //console.log("SignUp ===>", data );
                        //add user and user id to session.
                        sessionStorage.setItem("user", JSON.stringify(data.Object));
                        sessionStorage.setItem("UserId", data.Object.UserId);
                    }

                });
                 
            },
            terms() {
                this.isModalVisible = false;
                this.$emit('showTerms', null);
            }
        }
    };
</script>


